// PdfViewerDialog.jsx
import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import "primereact/resources/themes/lara-light-cyan/theme.css";
// import axios from "axios";
// import * as Yup from "yup";
// import { auth_key, url } from "../Assets/Addresses/BaseUrl";
// import { Message } from "./Message";
// import { useFormik } from "formik";
// import TDInputTemplate from "./TDInputTemplate";
// import BtnComp from "./BtnComp";
// import VError from "./VError";
import award_a from "../Assets/images/award_a.png";
import award_b from "../Assets/images/award_b.png";
import award_c from "../Assets/images/award_c.png";


const AchievementData = [{
  award_a:{
    thum:award_a,
    title: 'Awarded To BENFED By Paradeep Phosphates Limited', 
    content: 'Awarded to BENFED by Paradeep Phosphates Limited as Best Institutional Agency for supplying quality suppliers to remote areas and as a result benefitting hundreds of farmers.'
  },
  award_b:{
    thum:award_b,
    title: 'PPL Awarded BENFED', 
    content: 'PPL awarded BENFED with 1st prize for outstanding performance in supplying fertilizers to remote areas of West Bengal.'
  },
  award_c:{
    thum:award_c,
    title: 'Awarded In Aspee products In West Bengal', 
    content: 'Awarded for achieving highest sale performance in Aspee products in West Bengal in the year 2000-2001.'
  },

}];

const AchievementDialog = ({ 
  visible, 
  onHide, 
  boxName, 
  // onAccountHeadAdded, 
  setAddMaster 
}) => {

  // const [loading, setLoading] = useState(false);
  // const [userDataLocalStore, setUserDataLocalStore] = useState([]);
  const selectedAward = AchievementData[0][boxName];

  // const validationSchema = Yup.object({
  //   account_head: Yup.string().required(`${title}` + " List is Required"),
  // });

  // useEffect(() => {
  //   const selectedAward = AchievementData[0][boxName];
  // }, []);


  // const addAccountHead = async () => {
  //   // setLoading(true);

  //   const formData = new FormData();
  //   // Append each field to FormData
  //   formData.append("account_head", formik.values.account_head);
  //   formData.append("created_by", userDataLocalStore.user_id);

  //   try {

  //     const response = await axios.post(`${url}index.php/webApi/Mdapi/accAdd`,
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //           'auth_key': auth_key // Important for FormData
  //         },
  //       }
  //     );

  //     console.log(response?.data?.status, 'ggggggggggg');


  //     if (response?.data?.status > 0) {
  //       Message("success", "Add successfully.");
  //       // setLoading(false);
  //       formik.resetForm();
  //       // fetchAccountHeadDropdownOption()
  //       if (onAccountHeadAdded) {
  //         onAccountHeadAdded();
  //         setAddMaster(false)
  //       }
  //     }

  //     if (response?.data?.status < 1) {
  //       // setLoading(false);
  //       Message("error", response?.data?.message);
  //     }





  //   } catch (error) {
  //     // setLoading(false);
  //     Message("error", "Error Submitting Form:");
  //     console.error("Error submitting form:", error);
  //   }

  // };

  // const onSubmit = (values) => {
  //   addAccountHead();
  // };

  // const formik = useFormik({
  //   initialValues,
  //   onSubmit,
  //   validationSchema,
  //   enableReinitialize: true,
  //   validateOnMount: true,
  // });

  return (

    <Dialog
      // header={'Add ' + boxName}
      header={selectedAward?.title}
      visible={visible}
      style={{ width: "50vw", maxWidth: "600px" }}
      onHide={onHide}
      dismissableMask={true}
      className="dialog_cus_add_achiev"
    >
     {selectedAward ? (
    <div style={{ textAlign: 'left' }}>
      
      <p><img src={selectedAward.thum} alt={selectedAward.title} style={{ maxWidth: "100%", height: "auto", float:'left'}} />{selectedAward.content}</p>
    </div>
  ) : (
    <p>No award data found for "{boxName}"</p>
  )}

    </Dialog>

  );
};

export default AchievementDialog;